import React from 'react';

const LibraryContentLoading = () => (
  <div className="library-content-loading" aria-busy="true" aria-label="Loading items">
    <div className="library-grid">
      {Array.from({ length: 12 }).map((_, index) => (
        <div
          key={index}
          className="library-skeleton-card"
          style={{ animationDelay: `${(index % 8) * 70}ms` }}
        >
          <div className="library-skeleton-thumb" />
          <div className="library-skeleton-meta">
            <span className="library-skeleton-line" />
            <span className="library-skeleton-line library-skeleton-line--short" />
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default LibraryContentLoading;
